import { LocationScope } from "@swivl-mono/types";
import { LayoutWithSidebar, Spinner } from "@swivl-mono/ui";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import { FacilityVarSet } from "../../../Helpers/FeatureFlags/facilityVarKeys";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";
import { Member } from "../../../Models/Member/Member.Current";
import LocationVarsModel from "../../../Models/Variables/LocationVars.Model";
import { SearchableSidebarLinksList } from "../../SidebarLink/SearchableSidebarLinksList";
import { RouterWorksheetData } from "../Types/Worksheet.Interface";
import { LocationDetailsHeader } from "./Header/Location.Details.Header";

interface Props {
  page: string;
  data: RouterWorksheetData[];
  showHeader?: boolean;
  /** Hides the sidebar's local "Search..." filter (Details v3 uses global search instead). */
  hideSidebarSearch?: boolean;
}

export function WorksheetLayoutView(props: Props) {
  const page = usePropertiesGetLocationIds();
  const { isLoaded } = LocationVarsModel.useState();
  useEffect(() => {
    LocationVarsModel.loadAllVariables();
  }, []);
  const shouldHide = page.type === LocationScope.ORG && !Member.canSeeOrgSettings ? true : false;
  // ENG-3299: Properties v3 (details-v3) lives on the Cortex variables; the
  // legacy Property Manager tabs (details, cortex) live on the legacy ones.
  const varSet: FacilityVarSet = props.page === "details-v3" ? "cortex" : "legacy";
  if (shouldHide) {
    return <> </>;
  }
  return (
    <LayoutWithSidebar
      sidebar={
        <SearchableSidebarLinksList
          page={page}
          prefix={page.preamble + "/page/" + props.page}
          postfix={page.action}
          items={props.data}
          hideSearch={props.hideSidebarSearch}
        />
      }
      contentNoPadding={true}
      content={
        !isLoaded ? (
          <Spinner />
        ) : props.showHeader ? (
          <LocationDetailsHeader {...page} varSet={varSet} key={"p" + page.path}>
            <Outlet />
          </LocationDetailsHeader>
        ) : (
          <div className="p-5" key={"o" + page.path}>
            <Outlet />
          </div>
        )
      }
    />
  );
}
